export default __webpack_public_path__ + "static/media/icon-pathwayreport_recovery.e44871e3.png";